import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from '../reducers'
import thunk from 'redux-thunk'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import firestore from '../firestore'
import firebase from '../firebase'
import * as GeoFirestore from 'geofirestore'

export const geoFirestore = GeoFirestore.initializeApp(firestore)

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['options'],
}

const store = createStore(
    persistReducer(persistConfig, rootReducer),
    composeWithDevTools(
        applyMiddleware(
            thunk.withExtraArgument({ firestore, firebase, geoFirestore })
        )
    )
)

export default store
